import { normalize } from "../common";
import { CONTAINER_NAME } from "../_utils/constant";
var back = normalize.back(function (options) {
  var _ref = options || {},
    success = _ref.success,
    fail = _ref.fail,
    complete = _ref.complete;
  setTimeout(function () {
    try {
      history.go(-1);
      success && success();
      complete && complete();
    } catch (e) {
      fail && fail(e);
      complete && complete(e);
    }
  });
}, CONTAINER_NAME.WEB);
export default back;